<section class="testimonials position-relative py-lg-5">
  <div class="container position-relative z-1 py-5">

    <h2 class="testimonials__title display-3 mb-5">Trusted by Britain's pet owners</h2>

    <div class="testimonials__desktop d-none d-lg-block">
      <app-trustbox-testimonials-desktop></app-trustbox-testimonials-desktop>
    </div>

    <div class="testimonials__mobile d-lg-none">
      <app-trustbox-testimonials-mobile></app-trustbox-testimonials-mobile>
    </div>

  </div>

  <app-background-icon
    src="/assets/images/icons/pet_birthday-cream.svg"
    [top]="20"
    [left]="15"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/cat-cream.svg"
    [top]="20"
    [left]="80"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/bone-cream.svg"
    [top]="80"
    [left]="15"
    [width]="150"
    [opacity]="0.5"
  />
  <app-background-icon
    src="/assets/images/icons/carry_crate-cream.svg"
    [top]="80"
    [left]="80"
    [width]="150"
    [opacity]="0.5"
  />

</section>